<script>
import options from './Modal.options'
export default options
</script>
<template>
    <dialog 
        v-if="open"
        class="nyk-modal" 
        :class="modalStyles" 
        ref="modalElementRef" 
        aria-labelledby="dialog-title"
    >
        <div class="nyk-modal__wrapper">
            <div class="nyk-modal__body">
                <div class="nyk-modal__body__header">
                    <slot name="header">
                        <h2 id="dialog-title" class="nyk-modal__body__title">{{ title }}</h2>
                        <h3 v-if="subtitle" class="nyk-modal__body__subtitle">{{ subtitle }}</h3>
                    </slot>

                    <button
                        @click="closeModal"
                        autofocus
                        class="nyk-modal__body__close"
                        aria-describedby="dialog-title"
                        :aria-label="closeAriaLabel"
                    >
                        <svg role="presentation" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M17.5588 7.50011L7.49816 17.5608L6.4375 16.5001L16.4982 6.43945L17.5588 7.50011Z"
                                fill="#07094A" />
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M7.49816 6.43945L17.5588 16.5001L16.4982 17.5608L6.4375 7.50011L7.49816 6.43945Z"
                                fill="#07094A" />
                        </svg>
                    </button>
                </div>

                <div class="nyk-modal__body__content">
                    <slot name="body"></slot>
                </div>

                <div v-if="$slots.footer" class="nyk-modal__body__footer">
                    <slot name="footer"></slot>
                </div>
            </div>

            <Loader v-if="isLoading"></Loader>
        </div>
    </dialog>
</template>
